"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const translation_1 = require("../../../common/js/helper/translation");
const NotificationStore_1 = __importDefault(require("../../stores/NotificationStore"));
const NotificationItem_1 = __importDefault(require("./NotificationItem"));
const NotificationDropdown = () => (react_1.default.createElement("div", { className: "znd-notifications-dropdown" },
    react_1.default.createElement("div", { className: "znd-notifications-dropdown__title t-headline-3" }, (0, translation_1.t)('notifications.title')),
    react_1.default.createElement("div", { className: "znd-notifications-dropdown__item-wrapper" }, NotificationStore_1.default.notifications.map((notification, key) => {
        return react_1.default.createElement(NotificationItem_1.default, { key: key, item: notification });
    }))));
exports.default = NotificationDropdown;
